export default "__VITE_ASSET__BsVpbuSN__"